var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportShareTaxi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 0-2 2v10h2a3 3 0 1 0 6 0h6a3 3 0 1 0 6 0h2v-6l-6-6H3Zm0 2h4v4H3V7Zm3 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13 7H9v4h4V7Zm2 0h1l4 4h-5V7Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportShareTaxi);
export default __webpack_public_path__ + "static/media/ic_action_transport_share_taxi.b97f3a5168971c19415a24e4c4c1e10d.svg";
export { ForwardRef as ReactComponent };